export default { sha: '2a26c9aa01f7ecc53e185d4da1fd60795ea7a58d', buildNumber: 'undefined' }
